const locale = {
  COMMON: {
    TITLE_LOGIN: 'Login',
    COLH_ACCT_NO: 'Username',
    COLH_EMAIL: 'Email',
    COLH_CHECK_EMAIL: 'Confirm Email',
    TXT_ACCOUNT_DESC: 'Enter your username',
    COLH_CIPHER: 'Password',
    COLH_HELP_DOC: 'User Manual',
    TXT_CIPHER_DESC: 'Enter your password',
    BTN_FORGET_CIPHER: 'Forgot Password',
    BTN_LOGIN: 'Login',
    BTN_LOGIN_ING: 'Logging in ...',
    BTN_BACK_TO_LOGIN: 'Back to Login',
    BTN_RETURN: 'Back',
    BTN_SUBMIT: 'Submit',
    TITLE_MENUGROUP: 'Menu Group',
    TITLE_PURVIEW_POINT: 'Permission',
    TITLE_AVAILABLE_STRUCTURE: 'Visible Organization Structure',
    LABEL_OPERATION: 'Operations',
    ENABLE: 'Enabled',
    DISABLE: 'Disabled',
    MSG_SERVER_ERROR: 'System error. Please contact your system administrator.',
    MSG_NO_PERMISSION: 'Sorry. You do not have access permission. Please contact your system administrator.',
    MSG_ASSIGN_SUCCESS: 'User is assigned with the selected roles',
    MSG_ASSIGN_STRUCTURE_SUCCESS: 'User is assigned to the selected organization structure',
    MSG_ASSIGN_USER_GROUP_SUCCESS: 'User is assigned to the selected user groups',
    ERRMSG_NO_PERMISSION: 'You do not have access permission. Returning to the homepage.',
    TITLE_NO_PERMISSION: 'Access denied',
    TITLE_ERROR: 'Error',
    BTN_MANAGE: 'Manage',
    BTN_DELETE: 'Delete',
    BTN_REMOVE: 'Remove',
    BTN_CANCEL: 'Cancel',
    BTN_CONFIRM: 'OK',
    PRMTMSG_DELETE_SUCCEED: 'Operation succeeded',
    LABEL_NAME: 'Name',
    BTN_EDIT: 'Edit',
    PRMTMSG_NAME_NOT_REPEAT: 'Name already exists',
    HINT_INPUT_PLACEHOLDER: 'Enter',
    NO_CONTENT: 'No data',
    INLINE_NEEDED: 'Required',
    INLINE_NAME_MAX_LENGTH: 'Use a maximum of 20 characters',
    FORMMSG_INPUT: 'Description is required',
    BTN_LOGOUT: 'Logout',
    BTN_SWITCH_OU: 'Change Enterprise',
    TITLE_SWITCH_OU: 'Select an Enterprise / Organization',
    BTN_CHANGE_CIPHER: 'Change Password',
    BTN_RENAME: 'Rename',
    BTN_I_SEE: 'OK',
    TITLE_DELETE_FAIL: 'Failed to delete',
    NOT_FOUND1: 'Page not found',
    NOT_FOUND2: 'Sorry, you do not have access permission.',
    NOT_FOUND_MOBILE: 'You do not have access permission for the application',
    NO_AUTH1: 'You do not have access permission.',
    NO_AUTH2: 'Sorry, you do not have permission to access the application.',
    NO_AUTH3: 'Please contact your system administrator.',
    NOT_AUTH_MOBILE: 'Sorry, you do not have permission to access the application',
    TITLE_ADD_FAIL: 'Failed to add',
    TITLE_MODIFY_FAIL: 'Failed to edit',
    TITLE_WELCOME: 'Welcome!',
    COLH_DESCRIPTION: 'Description',
    TXT_NO_ROLE: 'No role found. Create a role or contact your system administrator.',
    NO_DATA: 'No matching results',
    PRMTMSG_EXIST_NAME: 'Name already exists',
    MSG_ACCOUNT_REQUIRED: 'Username is required',
    MSG_SOURCE_REQUIRED: 'Domain is required',
    MSG_FILE_TYPE_LIMIT: 'Format of the uploaded image is not supported',
    MSG_FILE_SIZE_LIMIT: 'Image size cannot exceed 2MB',
    MSG_TOKEN_EXPIRED: 'Initialization or reset information has expired',
    HINT_INVALID_PUBLIC_KEY: 'Login Failed. Please refresh the page and try again.',
    TXT_COPY_RIGHT: 'Powered by EnOS',
    TXT_COPY_RIGHT1: ' Powered by EnOS',
    BTN_LAN_SWITCH: 'Switch Language',
    BTN_CHANGE_ORGANIZATION: 'Change Enterprise/Organization',
    TITLE_SETTING: 'Settings',
    TITLE_CHANGE_CIPHER: 'Change Password',
    TXT_CHANGE_CIPHER_NOTE: 'For your account security, please change your password now.',
    TITLE_SELECT_ORGANIZATION: 'Select an Enterprise/Organization',
    TITLE_MENUBAR: 'Menu Bar',
    BTN_EXPAND: 'Expand',
    BTN_COLLAPSE: 'Collapse',
    TITLE_SESSION_CONFLICT: 'Your account has been logged in from another location',
    TXT_SESSION_CONFLICT: 'You have been logged out because your account was logged in from IP：{0}.',
    BTN_CHANGE_THEME: 'Change Navigation Bar Theme',
    TITLE_CHANGE_THEME: 'Change Navigation Bar Theme',
    TXT_CHANGE_THEME_HINT: 'Select a theme to change the color of the navigation bar',
    TXT_DARK_THEME: 'Dark',
    TXT_BLUE_THEME: 'Bluish green',
    TITLE_TOKEN_EXPIRED: 'Login Session Expired',
    TXT_EXPIRED_CONTENT: 'For security reasons, you have been logged out due to inactivity.',
    TITLE_MULTI_LANGUAGE: 'Multiple Languages',
    BTN_MORE: 'More',
    BTN_HIDE: 'Collapse',
    BTN_ADMIN: 'Administrator',
    TITLE_ADMIN_INFO: 'Administrator Info',

    TXT_LANGUAGE_EN: 'English(en-US)',
    TXT_LANGUAGE_ZH: 'Chinese(zh-CN)',
    TXT_LANGUAGE_JA: 'Japanese(ja-JP)',
    TXT_LANGUAGE_ES: 'Spanish(es-ES)'
  },

  ROLE: {
    TITLE_ROLE_MANAGE: 'Role',
    BTN_ADD_NEW_ROLE: 'New Role',
    HINT_SEARCH_BY_ROLE: 'Search by role name',
    COLH_NAME: 'Role Name',
    COLH_DESCRIPTION: 'Description',
    COLH_OPERATE: 'Operations',
    COLH_KEY_WORD: 'Keyword',
    FORMMSG_ROLE_MANAGE: 'Manage',
    FORMMSG_ROLE_DELETE: 'Delete',
    FORMMSG_ROLE_REMOVE: 'Remove',
    TITLE_ADDROLE: 'New Role',
    TITLE_CHOOSE_APP: 'Step 1. Select an application',
    TITLE_MODIFYROLE: 'Edit Role',
    TITLE_DELETE_ROLE: 'Failed to delete role',
    TITLE_CONFIRM_ROLE: 'Delete Role',
    LABEL_ADDROLE_NAME: 'Name',
    LABEL_ADDROLE_DESCRIPTION: 'Description',
    LABEL_MENUGROUP_NAME: 'Menu Group Name',
    LABEL_PERMISSION_NAME: 'Permission Name',
    LABEL_PERMISSION_DESC: 'Permission Description',
    LABEL_BELONG_APP: 'Application',
    TITLE_DELETE_FAIL: 'Failed to delete',
    BTN_CANCEL: 'Cancel',
    BTN_EDIT: 'Edit',
    BTN_SUBMIT: 'Submit',
    BTN_CONFIRM: 'OK',
    BTN_CHECK: 'OK',
    BTN_ASSIGNMENT_MENGROUP: 'Assign Menu Group',
    BTN_ASSIGNMENT_PURVIEW_POINT: 'Assign Permissions',
    TITLE_ASSIGNMENT_MENGROUP: 'Step 2. Select a menu group',
    TITLE_ASSIGNMENT_PURVIEW_POINT: 'Step 2. Select permissions',
    PRMTMSG_ADDROLE_SUCCESS: 'New role is created',
    PRMTMSG_DELROLE_SUCCESS: 'Role is deleted',
    PRMTMSG_EXIST_ROLE: 'Role name already exists',
    PRMTMSG_MODROLE_SUCCESS: 'Role is updated',
    PRMTMSG_REMMGROUP_SUCCESS: 'Menu group is removed',
    HINT_ADD_ROLE_PLACEHOLDER: 'Enter role name',
    HINT_ADD_ROLE_DESCRIPTION_PLACEHOLDER: 'Enter role description',
    PRMTMSG_ASSMGROUP_SUCCESS: 'Menu group is assigned to the role',
    PRMTMSG_ASSPERMISSION_SUCCESS: 'Permissions are assigned to the role',
    PRMTMSG_REMPERMISSION_SUCCESS: 'Permissions are removed from the role',
    WINMSG_ROLEDELETE_FAIL: 'The role has assigned users and cannot be deleted',
    WINMSG_CHECK: 'Close',
    WINMSG_DELETE_CHECK: 'The permissions associated with the role will also be removed. Are you sure you want to delete the role?',
    BTN_FORGET_CIPHER: 'Forgot Password',
    TXT_SELECTED_APP: 'Selected Application',
    INLINE_NAME_HINT: 'Use a maximum of 20 characters',
    MSG_ACCOUNT_REQUIRED: 'Role name is required',
    WINMSG_MENUGRP_DELETE_CHECK: 'The role will lose the permissions associated with the menu group. Are you sure you want to remove the menu group?',
    HOVER_ROLE_MENUGRP:
      'A menu group is a collection of menu that appear in an application. When you assign a menu group to a role, users of that role gain access to menus in the menu group.',
    HOVER_ROLE_PERMISSION:
      'A permission defines the operation that users can perform in applications. When you assign a permission to a role, users of that role can perform the defined operation in applications.',
    WINMSG_PERMISSION_DELETE_CHECK:
      'The role will lose access to the operations associated with the permission. Are you sure you want to remove the permission?',
    TITLE_DELETE_PERMISSION: 'Remove Permission',
    WINMSG_APP_NO_PERMISSION: 'No permissions have been configured for this application',
    WINMSG_APP_NO_MENUGROUP: 'No menus have been configured for this application',
    TITLE_DELETE_MENUGROUP: 'Remove Menu Group',
    TITLE_ASSGIN_MENU_GROUP: 'Assign Menu',
    TITLE_ROLE_DETAIL: 'Role Details',
    COLH_CREATE_BY: 'Created By',
    COLH_CREATE_TIME: 'Created On',
    HOVER_ROLE_STRUCTURE: 'Configure organization structures visible to the role. Users in this role can view the assigned organization structure.',
    BTN_ASSIGNMENT_STRUCTURE: 'Assign Organization Structure',
    LABEL_STRUCTURE_NAME: 'Organization Structure Name',
    TITLE_DELETE_STRUCTURE: 'Remove Visible Organization Structure',
    WINMSG_STRUCTURE_DELETE_CHECK: 'The role will no longer have access to this organization structure once removed. Are you sure you want to remove the organization structure?',
    PRMTMSG_REMSTRUCTURE_SUCCESS: 'Visible organization structure is removed',
    WINMSG_APP_NO_STRUCTURE: 'This application has no assigned organization structure',
    TITLE_ASSIGNMENT_STRUCTURE: 'Step 2: Select Organization Structure',
    PRMTMSG_ASSSTRUCTURE_SUCCESS: 'Visible organization structure is assigned'
  },
  USERGROUP: {
    TITLE_PAGENAME: 'User Group',
    BTN_ADD_USER_GROUP: 'New User Group',
    TITLE_ADD_USER_GROUP: 'New User Group',
    COLH_NAME: 'User Group Name',
    COLH_DESCRIPTION: 'Description',
    LABEL_NAME: 'Name',
    LABEL_DESCRIPTION: 'Description',
    INLINE_NAME_HINT: 'Use a maximum of 20 characters',
    BTN_OKTEXT: 'Submit',
    BTN_OKCONFIRM: 'OK',
    BTN_CANCELTEXT: 'Cancel',
    PRMTMSG_ADD_SUCCEED: 'User group is created',
    TITLE_MODIFY_USER_GROUP: 'Edit User Group',
    WINMSG_DELETE_HINT: 'The permissions associated with the user group will also be removed. Are you sure you want to delete the user group?',
    PRMTMSG_DELETE_SUCCEED: 'User group is deleted',
    BTN_OKTEXT_IKNOW: 'Close',
    HINT_SEARCH_USER_GROUP: 'Search by user group name',
    TITLE_CONFIRM_DELETE: 'Delete User Group',
    INLINE_DESCRIPTION_MAX_LENGTH: 'Use a maximum of 50 characters',
    PRMTMSG_MODIFY_SUCCEED: 'User group information is updated',
    HINT_ADD_USER_GROUP_PLACEHOLDER: 'Enter user group name',
    HINT_ADD_USER_GROUP_DESCRIPTION_PLACEHOLDER: 'Enter user group description',
    MSG_USER_GROUP_NAME_NEEDED: 'User group name is required',
    MSG_USER_GROUP_DESCRIPTION_NEEDED: 'Description of the user group is required',

    BTN_VIEW: 'View',
    COLH_ASSIGNED_USER: 'Assigned Users',
    COLH_CREATE_BY: 'Created By',
    COLH_CREATE_TIME: 'Created On'
  },
  MENU: {
    BTN_APP_MGR: 'Application Management',
    BTN_USER_PERMISSION: 'User and Permission',
    BTN_USER_MGR: 'User',
    BTN_ROLE_MGR: 'Role',
    BTN_USER_GROUP_MGR: 'User Group',
    BTN_STRUCTURE_MGR: 'Organization Structure',
    BTN_SUB_ADMIN_MGR: 'Sub-Administrator',
    BTN_ASSET_PERMISSION_MGR: 'Asset Permission',
    BTN_OTHER_MGR: 'Other Settings',
    BTN_ASSET_MGR: 'Asset Management',
    BTN_OU_CONF: 'OU Configuration',
    BTN_ASSET_SYN: 'Asset Synchronization',
    BTN_ASSET_TREE: 'Asset Tree',
    BTN_OU_MGR: 'OU Administrator',
    BTN_PLUGIN_MGR: 'Plugin Management',
    BTN_OU: 'OU',
    BTN_DOMAIN: 'Domain Configuration',
    BTN_SECURITY_SETTING: 'Security Settings',
    BTN_ACCOUNT_PROTECTION: 'Account Protection',
    BTN_SECURITY_MGR: 'Security Management',
    BTN_AUDIT_LOG: 'Audit Log'
  },
  MENU_GROUP: {
    BTN_ADD_MENU_GROUP: 'New Menu Group',
    DEFAULT_MENU_GROUP: 'Default Menu Group',
    TITLE_ADD_MENU_GROUP: 'New Menu Group',
    PRMTMSG_ADD_SUCCEED: 'New menu group is created',
    TITLE_MODIFY_MENU_GROUP: 'Rename Menu Group',
    PRMTMSG_MODIFY_SUCCEED: 'Menu group is renamed',
    TITLE_CONFIRM_DELETE: 'Delete Menu Group',
    WINMSG_DELETE_HINT:
      'The associations with the menu group will also be removed. Are you sure you want to delete the menu group?',
    PRMTMSG_DELETE_SUCCEED: 'Menu group is deleted',
    TITLE_ASSGIN_MENU_GROUP: 'Manage Menus',
    BTN_ASSGIN_MENU_GROUP: 'Manage Menus',
    TXT_MENU_GROUP: 'Menu Group',
    TXT_ASSGIN_MENU: 'Assigned Menus'
  },
  APP: {
    COLH_NAME: 'Application Name',
    TITLE_CATEGORY: 'Application Category',
    TITLE_PAGENAME: 'Application',
    COLH_STATUS: 'Enable',
    COLH_STRUCTURE: 'Organization Structure',
    HINT_ASSIGN_STRUCTURE: 'Assign Organization Structure',
    TITLE_ASSIGN_STRUCTURE: 'Assign Organization Structure',
    MANAGE_MENU_GROUP: 'Manage Menu Groups',
    TITLE_ClOSE_APP_STATUS: 'Disable Application',
    TITLE_OPEN_APP_STATUS: 'Enable Application',
    WINMSG_ClOSE_APP_STATUS_HINT:
      'The application will be hidden from the application launcher for all users. Are you sure you want to disable the application?',
    WINMSG_OPEN_APP_STATUS_HINT:
      'The application will appear in the application launcher for authorized users. Enable the application?',
    HINT_CHANGE_STRUCTURE: 'Change organization structure',
    TITLE_APP_MANAGE: 'Application',
    BTN_SORT: 'Sort',
    TXT_SORT_WARNING: 'Configure the sort order of applications in the application launcher.',
    HINT_CAN_NOT_SORT: 'No applications found',
    BTN_CREATE_SHORTCUT_APP: 'New Shortcut',
    BTN_MGR_SHORTCUT_APP: 'Manage Shortcut',
    BTN_DELETE_SHORTCUT_APP: 'Delete Shortcut',
    TITLE_SHORTCUT: 'Shortcut',
    TITLE_DELETE_SHORTCUT_MODAL: 'Delete Shortcut',
    CONTENT_DELETE_SHORTCUT_MODAL: 'Deleted shortcuts cannot be recovered. Are you sure you want to delete the shortcut?',
    MSG_DELETE_SHORTCUT_SUCCESS: 'Shortcut is deleted',
    TXT_SHORTCUT_DETAIL: 'Shortcut Details',
    TITLE_ADD_SHORTCUT_FAIL: 'Failed to create the shortcut',
    MSG_ADD_SHORTCUT_SUCCESS: 'Shortcut is created',
    COLH_MAIN_APP: 'Main Application',
    COLH_APP_NAME: 'Name',
    COLH_NAME_ZH: 'Name (Chinese)',
    COLH_NAME_EN: 'Name (English)',
    COLH_CATEGORY: 'Application Category',
    COLH_DESCRIPTION: 'Description',
    TITLE_MODIFY_BASIC_INFO: 'Edit Basic Information',
    MESSAGE_MODIFY_SUCCEED: 'Basic information is updated',
    TITLE_ADDED_APP: 'Added Menus',
    BTN_ADD_MENU: 'Add Menus',
    TXT_ADD_FROM_OTHER_APP: 'Add from other applications',
    TXT_ADD_FIRST_CLASS_MENU: 'Add top-level menu',
    TITLE_CHOOSE_APP: 'Step 1. Select an application',
    TITLE_ASSIGN_MENU: 'Step 2. Select menus',
    HINT_ADD_SUB_MENU: 'Add Sub-Menus',
    HINT_DELETE: 'Delete',
    HINT_EDIT: 'Edit',
    HINT_ADD_MENU_ZH_PLACEHOLD: 'Enter menu name in Chinese',
    HINT_ADD_MENU_EN_PLACEHOLD: 'Enter menu name in English',
    TITLE_CONFIRM_DELETE: 'Delete Menu',
    TXT_CONFIRM_DELETE: 'Deleted menus cannot be restored. Are you sure you want to delete the menu?',
    TITLE_CONFIRM_DELETE_AGAIN: 'Delete Top-Level Menu and Its Sub-Menus',
    HINT_DELETE_MENU_SUCCEED: 'Menu is deleted',
    HINT_CREATE_MENU_SUCCEED: 'Menu is added',
    HINT_ADD_MENU: 'You can add menus from other applications or add a new top-level menu.',
    WINMSG_APP_NO_MENU: 'No menus available',
    TXT_SOURCE: 'Source',
    BTN_API_AUTHORIZATION: 'API Authorization',
    MSG_API_AUTHORIZATION: 'API Authorization',
    TXT_API_AUTHORIZATION: 'Enable the application to perform the following operations through APIs',
    TXT_API_AUTHORIZATION_USER: 'Obtain the ID, username, email, and phone number of all users in the OU',
    TXT_API_AUTHORIZATION_ASSET: 'Obtain the ID and name of all assets in the OU',
    MSG_API_AUTHORIZATION_SUCCESS: 'API authorization settings are updated',
    BTN_VIEW_MENU: 'View Menus',
    BTN_SORT_MENU: 'Sort Menus',
    TXT_SORT_MENU_WARNING: 'Modify the sort order of the menus. The new sort order will take effect on the next user login.',
    HINT_MODIFY_MENU_SUCCESS: 'Menu is renamed',
    HINT_SORT_MENU_SUCCESS: 'Sort order of menus is updated',
    MESSAGE_ADD_NEEDED: 'Enter menu name',
    MESSAGE_RENAME_NEEDED: 'Enter shortcut name',
    MESSAGE_RENAME_MENU_GROUP_NEEDED: 'Enter menu group name',
    HINT_SORT_APP_SUCCESS: 'Applications are sorted with the new order',
    HINT_ASSIGN_APP_STRUCTURE: 'Organization structure is assigned',
    MSG_ADD_MENU_SUCCESS: 'Menus are added',
    MSG_SHORTCUT_NAME_NEEDED: 'Shortcut name is required',
    COLH_NAME_JA: 'Name (Japanese)',
    COLH_NAME_ES: 'Name (Spanish)',
    LABEL_URL: 'URL',
    TXT_API_AUTHORIZATION_ROLE: 'Obtain the ID and name of all roles in the OU',
    WINMSG_APP_NO_PERMISSION: 'No permissions available',
    TITLE_DELETE_PERMISSION: 'Delete Permission',
    WINMSG_PERMISSION_DELETE_CHECK:
      'The application shortcut will lose access to the operations associated with the permission. Are you sure you want to delete the permission?',
    TITLE_ADDED_PER: 'Added Permissions',
    BTN_ASSIGNMENT_PURVIEW_POINT: 'Add Permissions',
    HINT_ADD_PER: 'You can add permissions from other applications. After adding permissions, you can assign these permissions to roles to enable users to access the associated operations.',
    PRMTMSG_ASSPERMISSION_SUCCESS: 'Permissions added successfully',
    PRMTMSG_REMPERMISSION_SUCCESS: 'Permission deleted',
    TITLE_DOWNLOAD_NAME: 'UserList',
    TXT_STRUCTURE_SELECT: 'Select up to {0} organization structure',
    TITLE_UNBIND: 'Remove Assigned Organization Structure',
    WINMSG_UNBIND: 'The organization structure is assigned to roles. The roles can no longer view the organization structure once removed. Please proceed with caution.',
    NO_STRUCTURE: 'No available organization structure. Please create one first',
    BTN_ALL_APP: 'All Applications',
    BTN_PURCHASED_APP: 'Purchased Applications',
    BTN_SELFDESIGNED_APP: 'Customized Applications',
    COLH_NEWNAVIGATION: 'New Navigation Style',
    TXT_NEWNAVIGATION: 'If you disable the new navigation style, applications will stay the current style',
    TITLE_OLDNAVIGATION: 'Old Navigation Style',
    TXT_SHOW_MENU_NAME: 'Show labels',
    TXT_SHOW_ICON: 'Show icons',
    TXT_FOLDER_SUBMENU: 'Expand/collapse sub-menus',
    TXT_ICON_MENU: 'Show icons only',
    TITLE_CLOSE_NEWNAVIGATION: 'Disable New Navigation?',
    TXT_CLOSE_NEWNAVIGATION: 'If you disable new navigation, the navigation will switch to the old style without icons.',
    BTN_APP_MENUMANAGEMENT: 'Menu Management',
    TXT_MENU_MANAGEMENT: 'Menu management'
  },
  MENU_MANAGEMENT: {
    TXT_SEARCH: 'Search by menu name or identifier',
    COLH_MENU_ICON_NAME: 'Icon/label',
    COLH_MENU_CODE: 'Identifier',
    COLH_ORDER: 'Sort',
    COLH_URL: 'URL',
    TITLE_ADDITION: 'Details',
    TITLE_SWITCH: 'Turn to',
    TITLE_OPEN: 'Expand',
    TXT_SWITCHMENU: 'Open this sub-menu',
    TITLE_MENU_NAME: 'Name',
    TITLE_MENU_PROPERTY: 'Property',
    TITLE_OPEN_SUBMENU: 'Expand Sub-menu',
    TITLE_SWITCH_SUBMENU: 'Open Sub-menu',
    TITLE_SELECT_ICON: 'Select an Icon',
    BTN_SAVE: 'Save',
    MSG_ICON_SAVE_SUCCESSFULLY: 'Icon saved!'
  },
  STRUCTURE: {
    TITLE_STRUCTURE_MANAGE: 'Organization Structure',
    TITLE_MANAGE_STRUCTURE: 'Organization Structure',
    BTN_ADD_STRUCTURE: 'New Organization Structure',
    COLH_NAME: 'Organization Structure Name',
    WINMSG_DELETE_STRUCTURE_HINT:
      'Deleted organization structures cannot be recovered. Are you sure you want to delete the organization structure?',
    TITLE_ADD_STRUCTURE: 'New Organization Structure',
    PRMTMSG_ADD_SUCCEED: 'Organization structure is created',
    PRMTMSG_ADD_CHILD_SUCCEED: 'Node is added',
    DELETE_STRUCTURE_SUCCEED: 'Organization structure is deleted',
    INLINE_STRUCTURE_AMOUNT: 'A maximum of 5 organization structures can be created',
    COLH_AUTO_ASSGIN_STATUS: 'Automatic Asset Authorization',
    TITLE_ClOSE_STRUCTURE_AUTO_DISPATCH: 'Disable Asset Authorization',
    TITLE_OPEN_STRUCTURE_AUTO_DISPATCH: 'Enable Asset Authorization',
    WINMSG_ClOSE_STRUCTURE_AUTO_DISPATCH:
      'Users will lose access to all child assets of the nodes where users are assigned. Are you sure you want to disable automatic asset authorization',
    WINMSG_OPEN_STRUCTURE_AUTO_DISPATCH:
      'Users automatically gain access to all child assets of the nodes where users are assigned. Enable automatic asset authorization?',
    BTN_ADD_SUB_NODE: 'Add Child Node',
    BTN_MANAGE_ASSET: 'Manage Assets',
    BTN_MANAGE_USER: 'View User',
    TITLE_ADD_NODE: 'Add Child Node',
    LABEL_NODE_NAME_ZH: 'Node Name(zh-CN)',
    LABEL_NODE_NAME_EN: 'Node Name(en-US)',
    TITLE_CONFIRM_DELETE_STRUCTURE: 'Delete Organization Structure',
    TITLE_CONFIRM_DELETE: 'Delete Node',
    WINMSG_DELETE_HINT: 'Deleted nodes cannot be recovered. Are you sure you want to delete the node?',
    TITLE_MODIFY_STRUCTURE: 'Rename',
    PRMTMSG_ASSIGN_SUCCEED:
      'Asset assignment is updated. For security reasons, users can access the assigned assets only after 3 minutes.',
    TITLE_MANAGE_USER: 'View User',
    BTN_SYNC_ASSETS: 'Synchronize Assets',
    PRMTMSG_SYNC_SUCCEED: 'Assets are synchronized',
    BTN_SYNCING: 'Synchronizing...',
    HINT_SYNC_ASSETS_HINT: 'Click "Synchronize Assets" to synchronize assets from the OU',
    PRMTMSG_MODIFY_SUCCEED: 'Node is updated',
    UNASSIGNED_ASSET: 'Unassigned Assets',
    ASSIGNED_ASSET: 'Assigned Assets',
    HINT_ADD_STRUCTURE_PLACEHOLDER: 'Enter organization structure name',
    INLINE_NANME_NEEDED: 'Node name is required.',
    MSG_STRUCTURE_NAME_NEEDED: 'Organization structure name is required',
    MSG_STRUCTURE_NAME_PATTERN: 'Vertical bar "|" and comma "," "，" are not allowed.',
    INLINE_STRUCTURE_HINT:
      'An organization structure is an asset management hierarchy that uses nodes as management units. You can configure the organization structure to automatically enable users to access all child assets of the nodes where they are assigned.',
    BTN_USER: 'User',
    BTN_ASSET: 'Asset',
    LABEL_NAME: 'Name',
    BTN_ADD_TAG: 'Add Tag',
    BTN_EDIT_TAG: 'Edit Tag',
    LABEL_TAG_ID: 'Tag Key',
    MSG_TAG_ID_INPUT: 'Use only letters, numbers, underscores(_), hyphens (-), and slashes (/)',
    LABEL_TAG_VALUE: 'Tag Value',
    HINT_INPUT_TAG_VALUE: 'Enter a tag value',
    HINT_INPUT_TAG_ID: 'Enter a tag key',
    TAB_TAG: 'Tag',
    TITEL_DELETE_TAG: 'Delete Tag？',
    TXT_DELETE_TAG_HINT: 'Deleted tags cannot be recovered. Are you sure you want to delete the tag?',
    PRMTMSG_CREATE_TAG_SUCCEED: 'Tag added',
    PRMTMSG_MODIFY_TAG_SUCCEED: 'Tag edited',
    MSG_TAG_KEY_EXIST: 'This tag key already exists',
    MSG_DELETE_STRUCTURE_TAG_SUCCEED: 'Tag deleted',
    BTN_SORT: 'Sort Order',
    MSG_SORT_SUCCESS: 'Saved',
    MSG_SORT_FAILED: 'Saving failed',
    MSG_ASSETSORT_FAILED: 'Operation failed, please try again',
    TXT_SORT_WARNING: 'You can only reorder nodes within the same parent node. In other words, you cannot move a node to a different parent node.'
  },
  USER: {
    BTN_SEARCH: 'Search',
    TITLE_PAGE_NAME: 'User',
    TITLE_USER_DETAIL: 'User Details',
    TITLE_USER_ROLE: 'Assigned Roles',
    TITLE_USER_STRUCTURE: 'Assigned Organization Structure',
    TITLE_USER_USER_GROUP: 'Assigned User Groups',
    TITLE_MODIFY_USER: 'Edit User Information',
    BTN_CREATE_USER: 'Add User',
    TITLE_CREATE_USER_FAILED: 'Failed to add user',
    MSG_CREATE_USER_FAILED: 'The user already exists and cannot be added again',
    BTN_ASSIGN_ROLE: 'Assign Role',
    TITLE_ASSIGN_ROLE: 'Assign Role',
    BTN_ASSIGN_STRUCTURE: 'Assign Organization Structure',
    TITLE_ASSIGN_STRUCTURE: 'Assign Organization Structure',
    BTN_ASSIGN_USER_GROUP: 'Assign User Group',
    TITLE_ASSIGN_USER_GROUP: 'Assign User Group',
    TXT_SEARCH: 'Search by username or full name',
    BTN_MANAGE: 'Manage',
    BTN_REMOVE_FROM_OU: 'Remove from Enterprise / Organization',
    TITLE_REMOVE_FROM_OU: 'Remove User',
    MSG_REMOVE_FROM_USER_GROUP: 'Remove from User Group',
    MSG_REMOVE_FROM_OU:
      'When the user is removed, the user will not have access to the assets of the enterprise or organization. Are you sure you want to remove the user?',
    MSG_ASSIGN_ROLE: 'After being assigned to a role, the user will have the permissions of the role on menus and operation permission.',
    MSG_ASSIGN_USER_GROUP: 'After being added to a user group, the user will be assigned the corresponding permission to view assets.',
    MSG_ASSIGN_STRUCTURE:
      'After being added to an organization, the user will be assigned the corresponding permission to view assets of the organization structure.',
    MSG_REMOVE_SUCCESS: 'User is removed from the enterprise / organization',
    COLH_ACCT_NO: 'User',
    COLH_EMAIL: 'Email',
    COLH_NICKNAME: 'Full Name',
    COLH_PHONE: 'Phone',
    MSG_REMOVE_SELF: 'You cannot remove your own user account',
    TITLE_CONFIRM_ADD: 'Add User',
    MSG_CONFIRM_ADD_USER: 'Add user {0} to the current enterprise/organization?',
    TITLE_MAIL_TO: 'Send invitation email to:',
    MSG_ENTER_CORRECT_FORMAT: 'Enter a valid email address',
    MSG_EMAIL_NO_RESULT: 'No matching results. ',
    TITLE_CREATE_JOIN: 'Create a user account',
    MSG_CREATE_EMAIL_SUCCESS: 'User account is created and an invitation email has been sent to the user',
    MSG_CREATE_EMAIL_NO_EMAIL_SUCCESS: 'User account is created and added',
    MSG_ACCOUNT_EXIST: 'Username already exists',
    MSG_ACCOUNT_REQUIRED: 'Username is required',
    TXT_ENTER_EMAIL: 'Enter your email address',
    TXT_ENTER_USER_EMAIL: "Enter user's email address",
    MSG_CIPHER_NOT_SAME: 'Entered passwords do not match',
    MSG_ENTER_CIPHER: 'Enter your password',
    MSG_ENTER_EMAIL_AGAIN: 'Enter your email address again',
    MSG_ENTER_CIPHER_AGAIN: 'Enter your password again',
    LABEL_CIPHER: 'Set Password',
    LABEL_CONFIRM_CIPHER: 'Confirm Password',
    TITLE_RESET_CIPHER: 'Reset Password',
    BTN_RESET_CIPHER: 'Reset Password',
    TXT_CONFIRM_RESET_CIPHER: 'Reset Password',
    MSG_CONFIRM_RESET_CIPHER: 'An email for resetting the password will be sent to user. Are you sure you want to reset the password？',
    MSG_TRIGGER_RESET_CIPHER: 'Email for resetting the password is sent to user',
    MSG_RESET_CIPHER_SUCCESS: 'Returning to the login page...',
    BTN_REDIRECT_IM: 'Return Now',
    MSG_SEND_RESET_EMAIL_SUCCESSFULLY: '{0}, which will expire in 24 hours.',
    MSG_JUMP_TO_MAIL_BOX: 'Please check the email and reset your password immediately',
    BTN_CHANGE_CIPHER_SUCCESSFULLY: 'Password is updated',
    HOVER_USER_ROLE:
      'A role is a collection of functional permissions, such as menu access permissions and operation permissions. After assigning a role to a user, the user will gain access to the corresponding menus and operations.',
    HOVER_USER_PERMISSION:
      'After assigning users to nodes on an organization structure and enabling the automatic authorization of assets, users will automatically gain access to the child assets.',
    HOVER_USER_STRUCTURE:
      'After assigning multiple users to a user group and assigning asset permissions to the group, users in the same user group will have the same asset permissions. ',
    TITLE_CONFIRM_REMOVE_ROLE: 'Remove Role',
    TITLE_CONFIRM_REMOVE_STRUCTURE: 'Remove Organization Structure',
    TITLE_CONFIRM_REMOVE_USER_GROUP: 'Remove User Group',
    WINMSG_DELETE_CHECK: 'The user will lose the associated permissions. Are you sure you want to remove?',
    WINMSG_DELETE_ROLE_CHECK: 'The user will lose the permissions associated with the role. Are you sure you want to remove the role?',
    WINMSG_DELETE_STRUCTURE_CHECK:
      'The user will lose the permissions associated with the organization structure. Are you sure you want to remove the user from the organization structure?',
    WINMSG_SUB_DELETE_STRUCTURE_CHECK:
      'The user will lose the permissions associated with the organization structure. You will also not be able to manage the user anymore. Are you sure you want to remove the user from the organization structure?',
    WINMSG_DELETE_USERGROUP_CHECK:
      'The user will lose the permissions associated with the user group. Are you sure you want to remove the user from the user group?',
    PRMTMSG_REMOVE_SUCCEED: 'User role is removed',
    STRUCTURE_REMOVE_SUCCEED: 'User is removed from the organization structure.',
    USER_GROUP_REMOVE_SUCCEED: 'User is removed from the user group.',
    PRMTMSG_MODIFY_USER_SUCCEED: 'Updated successfully',
    COLH_DESCRIPTION: 'Description',
    COLH_USER_ROLE: 'Role',
    COLH_USER_STRUCTURE: 'Organization Structure',
    COLH_USER_USER_GROUP: 'User Group',
    MSG_ACCOUNT_NUMBER_REQUIRED: 'Enter a number',
    TXT_SELECTED_STRUCTURE: 'Selected Organization Structure',
    MSG_EMAIL_NOT_SAME: 'Entered email addresses do not match',
    LABEL_NEW_CIPHER: 'New Password',
    LABEL_OLD_CIPHER: 'Old Password',
    LABEL_CONFIRM_NEW_CIPHER: 'Confirm New Password',
    MSG_NO_CIPHER: 'Password is required',
    MSG_ENTER_OLD_CIPHER: 'Enter your old password',
    MSG_ENTER_NEW_CIPHER: 'Enter your new password',
    MSG_NEW_CIPHER_NOT_SIMILAR: 'Entered passwords do not match',
    MSG_NEW_OLD_CIPHER_SIMILAR: 'New password cannot be the same with old password',
    MSG_MODIFY_CIPHER_SUCCESS: 'Password is changed',
    MSG_ACCOUNT_CANNOT_CHANGE: 'Account type and domain cannot be changed',
    MSG_CREATE_ADD_USER: 'New User Account',
    MSG_INVALIDATE_CIPHER: 'Password does not comply with the password requirements',
    MSG_CIPHER_PATTERN:
      'A password must have at least 8 characters, including at least one uppercase letter, one lowercase letter, and one number. Special characters !@#%&$*()[]{}| are also supported.',
    HINT_USER_REQUIRED: 'Username is required',
    HINT_REGION_REQUIRED: 'Manageable scope is required',
    MSG_SUB_ADMIN_ADD_EXIST_USER: 'The user already exists and cannot be added again.',
    TITLE_USER_BATCH_IMPORT: 'Batch Import',
    BTN_BATCH_IMPORT: 'Batch Import',
    MSG_DOWNLOAD_IMPORT_TEMPLATE: 'Download template',
    MSG_UPLOAD_WRITTEN_FILE: 'Upload file',
    MSG_A_IMPORT_TEMPLATE_DOWNLOAD: 'Download template',
    TITLE_UPLOAD_FILE_ERROR: 'Upload Failed',
    TITLE_UPLOAD_FILE_FORMAT_ERROR: 'Invalid File Format',
    TITLE_UPLOAD_FILE_SIZE_ERROR: 'Records Exceed Limit ',
    MSG_UPLOAD_FILE_SIZE_ERROR: 'File size cannot exceed 2MB',
    MSG_UPLOAD_FILE_FORMAT_ERROR: ' Upload only .xls or .xlsx files',
    BTN_UPLOAD_SELECT: 'Select File',
    BTN_START_UPLOAD: 'Upload',
    TITLE_BATCH_IMPORT_EXPLANATION: 'The Batch Import function enables you to add multiple users and assign roles and organization structures at the same time. Download the template, fill up the required information in the template, and upload the file.',
    MSG_A_BATCH_IMPORT_EXPLANATION: 'File size limit: 2MB, Maximum user records per file: 1000, File format: {0}',
    TITLE_RECENT_FAILED_RECORD: 'Last import',
    MSG_A_DOWNLOAD_FAILED_IMPORT_RECORD: 'Download failed records',
    BTN_UPLOADING: 'Uploading',
    BTN_PROCESSING: 'Processing',
    MSG_HISTORY_SUCCESS_RECORDS: 'On {0}, you imported {1} member(s)',
    MSG_HISTORY_FAILED_RECORDS: ', and failed to import {0} member(s).',
    TITLE_TEMPLATE_NAME: 'Template.xlsx',
    TITLE_HISTORY_RECORDS_NAME: '{0}_Failed Records.xlsx',
    LABEL_USER_TYPE: 'Type',
    LABEL_USER_ACCOUNT_AD: 'Domain Account',
    LABEL_USER_ACCOUNT_INTERNAL: 'Internal Account',
    LABEL_USER_SOURCE: 'Domain',
    MSG_CIPHER_RULES: 'Password rules: {0}',
    TITLE_CONFIRM_RESET_CIPHER: 'Reset Password',
    MSG_CONFIRM_RESTE_CIPHER: 'The system will generate a new password. Are you sure you want to reset the password?',
    TITLE_CONFIRM_RESTE_CIPHER: 'The system will generate a new password automatically. Confirm reset password?',
    MSG_NOTICE_CONTENT: 'The system is unable to send an email notification to this user. Please send the login URL, username, and password to the user manually.',
    BTN_COPY_ACCOUNT_CIPHER: 'Copy',
    TXT_CORY_SUCCESS: 'The username and password have been copied.',
    TITLE_RESET_CIPHER_SUCCESS: 'Password is reset',
    TITLE_CREATE_ADD_ACCOUNT_SUCCESS: 'User account is created and added',
    HINT_INCORRECT_PHONE_NUMBER: 'Enter a valid phone number format',
    PLACEHOLD_SELECT_USER: 'Select',

    COLH_ACCOUNT_START_TIME: 'Valid From',
    HINT_ACCOUNT_START_TIME: 'The date on which the account is activated, and the user can start logging in to the OU',
    COLH_ACCOUNT_EXPIRE_TIME: 'Valid Through',
    HINT_ACCOUNT_EXPIRE_TIME: 'The last day on which the account is valid. The user can no longer log in to the OU after this date.',
    BTN_BATCH_EXPORT: 'Batch Export',
    TITLE_BATCH_EXPORT: 'Batch Export',
    COLH_CREATE_TIME: 'Created On',
    TITLE_COMPANY: 'Company',
    TITLE_DEPARTMENT: 'Department',
    TITLE_POSITION: 'Job Role'
  },
  SUB_ADMIN: {
    COLH_NAME: 'User',
    COLH_MANAGEMENT_REGION: 'Manageable Scope',
    COLH_AVAILABLE_ROLE: 'Manageable Roles',
    BTN_MANAGE: 'Manage',
    BTN_REMOVE_FROM_OU: 'Remove',
    TITLE_REMOVE_SUB_ADMIN: 'Remove Sub-Administrator',
    TEXT_REMOVE_SUB_ADMIN: 'The user will lose the administrative rights. Are you sure you want to remove the sub-administrator?',
    TITLE_REMOVE_FAIL: 'Failed to remove the sub-administrator',
    MSG_REMOVE_SUCCESS: 'Sub-administrator is removed',
    BTN_CREATE_SUB_ADMIN: 'Add Sub-Administrator',
    TEXT_COMMA: ',',
    TITLE_PAGE_NAME: 'Sub-Administrator',
    TITLE_NEW_SUB_ADMIN: 'Add Sub-Administrator',
    TITLE_MANAGE_SUB_ADMIN: 'Sub-Administrator Details',
    INLINE_SUB_ADMIN_DETAIL_HINT:
      'Sub-administrators can manage user permissions, such as assigning roles or asset permissions, in a specific organization structure.',
    TITLE_SELECT_USER: 'Select User',
    TITLE_SET_REGION: 'Select Manageable Scope',
    TITLE_SELECT_ROLE: 'Select Manageable Roles',
    TEXT_REGION_HINT:
      'Select the organization structures that the sub-administrator can manage.',
    TEXT_ROLE_HINT: 'Select the roles that the sub-administrator can assign to users.',
    BTN_SUBMIT: 'Submit',
    HINT_SELECT_USER: 'Search by username',
    HINT_SET_REGION: 'Select organization structures',
    HINT_SELECT_ROLE: 'Select roles',
    HINT_NO_MATCH_DATA: 'No matching results',
    HINT_USER_REQUIRED: 'Username is required',
    HINT_REGION_REQUIRED: 'Manageable scope is required',
    MSG_CREATE_SUCCESS: 'Sub-administrator is added',
    MSG_UPDATE_SUCCESS: 'Sub-administrator information is updated',
    BTN_VIEW: 'View',
    COLH_MANAGEMENT_AUTHORITY: 'Administrative Rights',
    COLH_ALLOCATION: 'Assignment Method',
    COLH_ASSIGNED_MANAGEMENT_REGION: 'Manageable Scope',
    TXT_SUBADMIN_NAME: 'Sub-Administrator',
    TITLE_SELECT_SUB_ADMIN: 'Sub-Administrator',
    HINT_SELECT_ALLOCATION: 'Select assignment method',
    HINT_SELECT_REGION: 'Select manageable scope',
    TITLE_SELECT_FUNCTION: 'Available Capabilities',
    TXT_APPLICATION: 'Applications Management', // 目前后端提供
    TXT_USER: 'User Management', // 目前后端提供
    TXT_ROLE: 'Roles Management', // 目前后端提供
    TXT_USER_GROUP: 'User Groups Management', // 目前后端提供
    TXT_ASSET_PERMISSION: 'Assign Asset Permissions', // 目前后端提供
    TXT_AUDIT_LOG: 'Audit Logs Management', // 目前后端提供
    TXT_ASSIGNED_BY_ORGANIZATION_STRUCTURE: 'Assign by organization structures',
    TXT_ASSIGNED_BY_USER_GROUP: 'Assign by user groups',
    TXT_ASSIGNED_BY_ROLE: 'Assign by roles',
    BTN_ADD: 'Add Assignment Method',
    TXT_DELETE_CONFIRM: 'Delete Assignment Method?',
    MSG_DELETE_CONFIRM: 'The sub-administrator will lose administrative rights for the selected scope',
    HINT_APPLICATION: 'Sub-administrators can manage the menu groups of applications',
    HINT_USER: 'Sub-administrators can create, edit, delete, batch import, and batch export user accounts. They can also assign roles, user groups, and organizational structure to users',
    HINT_ROLE: 'Sub-administrators can manage roles that are assigned to them or created by them',
    HINT_USER_GROUP: 'Sub-administrators can manage user groups that are assigned to them or created by them',
    HINT_ASSET_PERMISSION: 'Sub-administrators can assign asset permissions to users or user groups',
    HINT_AUDIT_LOG: 'Sub-administrators can view and export their own administrative events, and the login and logout events of users that they manage',
    HINT_ALLOCATIONS: 'Assign the user groups, roles, and assets, that the sub-administrator can manage',
    HINT_OPERATIONS: 'Select the capabilities of the sub-administrator',
    TXT_STRUCTURES: 'Organization Structure',
    TXT_ROLES: 'Role',
    TXT_USER_GROUPS: 'User Group'
  },
  ASSET_PERMISSION: {
    TXT_USER: 'User',
    TXT_USER_GROUP: 'User Group',
    HINT_SEARCH: 'Search by username',
    HINT_USER_SEARCH: 'Search by username or email',
    HINT_USER_GROUP_SEARCH: 'Search by user group name',
    BTN_MANAGE_ASSET: 'Manage Assets',
    COLH_NAME: 'Assigned Assets',
    TITLE_MANAGE_ASSET: 'Manage Assets',
    TXT_ASSGIN_TO: 'Assign to',
    TITLE_CONFIRM_REMOVE: 'Remove Asset',
    ASSET_PERMISSION_USER: 'The user will lose access to the asset. Are you sure you want to remove the asset?',
    ASSET_PERMISSION_USER_GROUP: 'The user group will lose access to the asset. Are you sure you want to remove the asset?',
    UNASSIGNED_ASSET: 'Unassigned Assets',
    ASSIGNED_ASSET: 'Assigned Assets',
    INLINE_ASSET_PERMISSION_DETAIL_HINT:
      'Assign assets to users or user groups so that they can view the corresponding asset data in the applications.'
  },
  ASSET_TREE: {
    BTN_MANAGE: 'Manage',
    TITLE_PAGENAME: 'Manage Organization Structure',
    TITLE_ASSET_SYNC:
      'Asset synchronization is the process of synchronizing connected and tagged assets from EnOS Console. Asset permissions can be assigned to users only after the synchronization is completed.',
    COLH_ASSET_NAME: 'Asset Name',
    COLH_SYNC_TIME: 'Synchronized On',
    MSG_SYNC_ASSET_TREE_FAIL: 'Please try again later',
    MSG_SYNC_ASSET_TREE_SUCCESS: 'Synchronization completed',
    BTN_SYNC_ING: 'Synchronizing',
    MSG_PROMPT_ASSETS_ALLOCATION: 'For security reasons, after assigning assets, users can access the assigned assets only after 3 minutes.'
  },
  OU: {
    TITLE_INFO: 'Basic Information',
    TITLE_ADMIN: 'OU Administrator',
    TITLE_PERSONALITY: 'Customization',
    TITLE_OU_NAME: 'OU Name',
    TITLE_OU_ADDRESS: 'Address',
    TITLE_INDUSTRY: 'Industry',
    TITLE_LOGO: 'Logo',
    TITLE_ADMIN_ACCOUNT: 'Administrator Account',
    TITLE_ADMIN_NAME: 'Administrator Name',
    BTN_CHANGE_MANAGER: 'Change Administrator',
    TITLE_CHANGE_MANAGER: 'Change Administrator',
    LABEL_CURRENT_ADMIN: 'Current Administrator',
    LABEL_NEW_ADMIN: 'New Administrator',
    TITLE_CHANGE_ADMIN: 'Change Administrator',
    WINMSG_CHANGEADMIN_HINT1: '{0} will be set as the new administrator.',
    WINMSG_CHANGEADMIN_HINT2: 'You will not be the administrator anymore.',
    WINMSG_CHANGEADMIN_HINT3: 'Are you sure you want to change the administrator?',
    HINT_NO_MATCH_DATA: 'No matching data found',
    HINT_INPUT_HINT: 'Search by username or email',
    INLINE_NEEDED: 'New administrator is required',
    BTN_REUPLOAD: 'Upload Image',
    MSG_FILE_UPLOAD_SUCCEED: 'Image is uploaded',
    TXT_CHANGE_LOGO_HINT: 'The logo will be displayed on the top navigation bar. You are recommended to use an image with these specifications: 200 * 32 pixels, transparent background, PNG or SVG format.',
    TXT_SEARCH: 'Search by OU name',
    TITLE_LANGUAGE_SETTING: 'Language Settings',
    TITLE_LANGUAGE: 'Available Languages',
    TXT_EDIT: 'Edit',
    TITLE_LAN_SETTING: 'Language Settings',
    HINT_EDIT_LAN_HINT: 'Select the languages available for all users in the enterprise or organization.',
    HINT_LANG_SETTING_SUCCEED: 'Language settings are updated',
    TITLE_PAGEFOOTER: 'Footer',
    TITLE_EDITPAGEFOOTER: 'Edit Footer',
    MSG_NULLFOOTER: 'The footer is blank',
    TXT_NULL: '(Blank)',
    MSG_EDITPAGEFOOTER_SUCCESS: 'The footer is saved',
    HINT_NOTBUY: 'The current OU hasn\'t purchased this function'
  },
  PORTAL: {
    BTN_ADMIN_CONSOLE: 'Admin Console',
    TITLE_IFRAME_ERROR: 'Iframe error',
    MSG_INVALIDATE_URL: 'Invalid menu URL',
    MSG_LOADING_FRAME: 'Loading...',
    NO_APP: 'No applications available',
    BTN_CHANGE_APP: 'Change Application'
  },
  SUPER: {
    TITLE_ASSIGN_OU_ADMIN: 'Assign Administrator',
    TITLE_RESET_ADMIN_CIPHER: 'Reset Administrator Password',
    TITLE_CONFIRM_RESET_CIPHER: 'Are you sure you want to reset the administrator password?',
    MSG_CONFIRM_RESET_CIPHER: 'Email for resetting the administrator password will be sent to:',
    MSG_CREATE_USER_AS_ADMIN: 'Create an administrator account',
    MSG_CONFIRM_SET_ADMIN: 'Assign the user as the administrator?',
    TXT_CONFIRM_SET_ADMIN: '{0} will be assigned as the administrator, and an invitation email will be sent to {1}. Proceed to send the email?',
    TXT_EDGE_CONFIRM_SET_ADMIN: 'Assign {0} as the administrator?',
    TITLE_OU_NAME: 'OU Name',
    TITLE_CURRENT_OU: 'Current Administrator',
    TITLE_NOT_ASSIGN: '(Administrator not Assigned)',
    MSG_CONFIRM_CHANGE_ADMIN: 'Are you sure to change the administrator?',
    TXT_CONFIRM_CHANGE_ADMIN1: 'The administrator will change from {0} to {1}',
    TXT_CONFIRM_CHANGE_ADMIN2: 'An invitation email will be sent to {0}. Confirm to send the email?',
    MSG_SEND_EMAIL_SUCCESSFULLY: 'Email sent'
  },
  PLUGIN: {
    BTN_REGISTER_PLUGIN: 'Register Plugin',
    TITLE_PLUGIN_NAME: 'Name',
    TITLE_NAME_DEFAULT: 'Name',
    TITLE_NAME_ENGLISH: 'Name (ENGLISH)',
    TITLE_URL: 'URL',
    TITLE_DESCRIPTION: 'Description',
    BTN_ASSIGN_OU: 'Assign OU',
    HINT_ADD_PLUGIN_NAME_PLACEHOLDER: 'Enter plugin name',
    HINT_ADD_PLUGIN_URL_PLACEHOLDER: 'Enter a valid URL',
    BTN_CANCELTEXT: 'Cancel',
    BTN_OKTEXT: 'Submit',
    TITLE_MODAL_REGISTER_PLUGIN: 'Register Plugin',
    TITLE_MODAL_MODIFY_PLUGIN: 'Edit Plugin',
    TITLE_MODAL_ASSIGN_OU: 'Assign OU',
    TITLE_MODAL_DELETE_PLUGIN: 'Delete Plugin',
    CONTENT_MODAL_DELETE_PLUGIN: 'Deleted plugins cannot be recovered. Are you sure you want to delete the plugin?',
    CONTENT_MODAL_DELETE_PLUGIN_FAILED1: 'The plugin has assigned users and cannot be deleted.',
    CONTENT_MODAL_DELETE_PLUGIN_FAILED2: 'Remove the assigned OU before deleting the plugin.',
    INPUT_NAME_NEEDED: 'Plugin name is required',
    INPUT_NAME_CHINESE_NEEDED: 'Plugin name (ZH) is required',
    INPUT_NAME_ENGLISH_NEEDED: 'Plugin name (EN) is required',
    INPUT_URL_NEEDED: 'Plugin URL is required',
    INPUT_DESCRIPTION_NEEDED: 'Plugin description is required',
    MESSAGE_REGISTER_SUCCEED: 'Plugin is registered',
    MESSAGE_MODIFY_SUCCEED: 'Plugin is updated',
    MESSAGE_ASSIGN_OU: 'OU is assigned',
    MESSAGE_DELETE_SUCCESS: 'Plugin is deleted',
    MSG_ASSIGN_OU: 'After the plugin is assigned to the OU, the OU administrator can use the plugin.',
    TXT_OU: 'OU',
    TXT_SELECTED_OU: 'Selected OU'
  },
  MESSAGE: {
    TITLE_NAME: 'Notifications',
    TXT_SHOW_ALL: 'View all',
    TXT_NO_MESSAGE: 'No message',
    TXT_TO_SOUND: 'Enable Sound',
    TXT_TO_MUTE: 'Disable Sound',
    TXT_DISABLE_DIALOG: 'Disable Pop-up',
    TXT_DIALOG: 'Enable Pop-up',
    TXT_CLOSE_DIALOG: 'Close',
    TXT_APP_HINT1: '{0} application(s) and {1} alert(s) remain',
    TXT_APP_HINT2: 'Collapse',
    TXT_MESSAGE: 'Message',
    TXT_LOAD_MORE: 'Load more',
    TXT_LOADING: 'Loading',
    TXT_LOAD_FAILED: 'Loading failed, please try again'
  },
  DOMAIN: {
    BTN_ADD_DOMAIN: 'Add Domain',
    TXT_DOMAIN_NAME: 'Domain Name',
    TXT_DOMAIN_URL: 'URL',
    TXT_DOMAIN_DESCRIPTION: 'Description',
    TITLE_ADD_DOMAIN: 'Add Domain',
    MESSAGE_ADD_SUCCEED: 'Domain is added',
    TITLE_MODIFY_DOMAIN: 'Edit Domain',
    MESSAGE_MODIFY_SUCCEED: 'Domain information is updated',
    TITLE_MODAL_DELETE_DOMAIN: 'Delete Domain',
    CONTENT_MODAL_DELETE_DOMAIN: 'Deleted domains cannot be recovered. Are you sure you want to delete the domain? ',
    MESSAGE_DELETE_SUCCESS: 'Domain is deleted',
    HINT_ADD_URL_PLACEHOLDER: 'Enter a valid URL',
    TXT_ADD_DOMAIN:
      'Add the domains of your enterprise or organization to enable the addition of domain user accounts',
    TXT_DOMAIN_NAME_NEEDED: 'Domain name is required',
    TXT_DOMAIN_URL_NEEDED: 'Domain URL is required',
    TXT_AUTO_IMPORT: 'Auto-import Users', // TODO
    TXT_YES: 'Yes', // TODO
    TXT_NO: 'No', // TODO
    TXT_ROLES: 'Roles',
    TXT_USER_GROUPS: 'User groups',
    TXT_SELECT_ROLES: 'Select roles', // TODO
    TXT_SELECT_USERGROUPS: 'Select user groups', // TODO
    HINT_NOT_AUTO_IMPORT: 'Manually create EnOS users for SSO in advance', // TODO
    HINT_AUTO_IMPORT: 'Application Portal supports automatically importing SSO users and assigning to roles and user groups. Select "yes" to automatically assign SSO users to selected roles and user groups; Select "No", you need to manually create users in advance in Application Portal.', // TODO
    HINT_AUTO_IMPORT_NECESSARY: 'You need to specify whether to auto-import users', // TODO
    TITLE_DOUBLE_CHECK: 'Are you sure to disable auto-import users?', // TODO
    TXT_DOUBLE_CHECK: 'After disabling auto-import users, you need to create users for SSO in advance. The existing users will remain in current roles and user groups.' // TODO
  },
  SECURITY: {
    TAB_CIPHER_RULES: 'Password Rules',
    TAB_LOGIN_SECURITY: 'Login Security',
    MSG_CIPHER_RULES: 'The following password rules apply to all internal user accounts in this environment',
    MSG_LOGIN_SECURITY: 'The following login security rules apply to all user accounts in this environment',
    LABEL_CIPHER_REQUIRED: 'Required Characters',
    TITLE_CIPHER_REQUIRED: 'Select at least 1 option',
    LABEL_CIPHER_LENGTH: 'Password Length',
    LABEL_CIPHER_LENGTH_AFTER: 'characters',
    LABEL_CIPHER_LENGTH_BOTTOM: 'Supports 8 - 20 characters',
    LABEL_CIPHER_RETRY_CONSTRAINT: 'Retry Limit',
    LABEL_CIPHER_RETRY_CONSTRAINT_AFTER: 'times/hour',
    LABEL_CIPHER_RETRY_CONSTRAINT_BOTTOM: 'The number of incorrect password entries allowed in 1 hour. The account will be locked for 1 hour if this limit is exceeded. Supports 1 - 10 retries.',
    LABEL_REPEAT_TIMES: 'Reuse Limit',
    LABEL_REPEAT_TIMES_AFTER: 'times',
    LABEL_REPEAT_TIMES_BOTTOM: 'The number of previous passwords that cannot be reused when users reset or change their password. Supports 1 to 5 passwords.',
    LABEL_SINGLE_OR_MORE: 'Multiple Login Sessions',
    LABEL_SINGLE_OR_MORE_BOTTOM: 'When enabled, users can log in to an account from multiple locations at the same time.',
    TITLE_OPEN_MORE_LOGIN: 'Enable Multiple Login Sessions',
    CONTENT_OPEN_MORE_LOGIN: 'When enabled, users can log in to an account from multiple locations at the same time.',
    TITLE_CLOSE_MORE_LOGIN: 'Disable Multiple Login Sessions ',
    CONTENT_CLOSE_MORE_LOGIN: 'When disabled, the currently logged in user will be logged out and notified that the same account has been logged in from another location.',
    LABEL_SESSION_VALID_TIME: 'Session Timeout',
    LABEL_SESSION_VALID_TIME_AFTER: 'minutes',
    LABEL_SESSION_VALID_TIME_BOTTOM: 'The period of time a user can stay inactive before they get logged out. Supports 15 - 720 minutes.',
    LABEL_IP_ADDRESS: 'IP Address',
    LABLE_IP_ADDRESS_WHITE: 'White List',
    LABEL_IP_ADDRESS_BLACK: 'Black List',
    PLACEHOLD_IP_ADDRESS: 'Separate IP addresses with commas',
    LABEL_IP_ADDRESS_BOTTOM_WHITE: 'White List: Internal users can log in only from the IP addresses listed.',
    LABEL_IP_ADDRESS_BOTTOM_BLACK: 'Black List: Internal users cannot log in from the IP addresses listed.',
    TITLE_SWITCH_IP_LIST_MODAL: 'Switch White/Black List',
    CONTENT_SWITCH_IP_LIST_MODAL: 'The listed IP addresses will be lost after switching the list. Are you sure you want to switch? ',
    TITLE_ILLEGAL_IP: 'Invalid IP address or CIDR address',
    TITLE_LENGTH_BEYOND: 'You can add a maximum of 500 IP addresses',
    TXT_LENGTH_HINT: 'Use {0} - 20 characters',
    TXT_UPPERCASE_HINT: 'Uppercase letters are required',
    TXT_LOWERCASE_HINT: 'Lowercase letters are required',
    TXT_MUNBER_HINT: 'Numbers are required',
    TXT_SPECIAL_CHARACTER_HINT: 'Special characters !@#%&*()[]{}-_=| are required',
    MESSAGE_SET_CIPHER_RULES_SUCCESS: 'Password rules are updated',
    MESSAGE_SET_SECURITY_LOGIN_SUCCESS: 'Login security settings are updated',
    TXT_CIPHER_TYPE_NUMBER: 'Numbers',
    TXT_CIPHER_TYPE_UPPERCASE: 'Uppercase letters',
    TXT_CIPHER_TYPE_LOWERCASE: 'Lowercase letters',
    TXT_CIPHER_TYPE_CHARACTER: 'Special characters !@#%&*()[]{}-_=|',
    BTN_SUBMIT_SECURITY: 'Apply Changes'
  },
  AUDIT: {
    TXT_AUDIT_LOG: 'Audit log contains the login, logout, and system operation events of all users in the OU for the past {0} days.',
    BTN_EXPORT: 'Export',
    BTN_EXPORT_LOADING: 'Exporting',
    TITLE_EVENT_TIME: 'Event Time',
    TITLE_ACCOUNT: 'User',
    TITLE_EMAIL: 'Email',
    TITLE_ACCOUNT_TYPE: 'Account Type',
    TITLE_ASSET_TYPE: 'Resource Type',
    TITLE_EVENT_NAME: 'Event',
    TITLE_EVENT_DESCRIPTION: 'Description',
    TITLE_IP_ADDRESS: 'IP Address',
    TITLE_OPERATION: 'Operation',
    TITLE_SEARCH_ACCOUNT: 'Search users',
    BTN_SEARCH_ACCOUNT: 'Search',
    BTN_RESET_ACCOUNT: 'Reset',
    BTN_VIEW_CONTENT: 'View Details',
    TXT_SEMICOLON: '；',
    TITLE_MODAL_DETAIL: 'Event Details',
    TITLE_MODAL_EXPORT: 'Export Log',
    TXT_MODAL_EXPORT1: 'Export audit logs for the selected time period?',
    TXT_MODAL_EXPORT2: 'If you need to export events that occurred before the past {0} days, please contact your system administrator.',
    TITLE_DETAIL_EDIT_BEFORE: 'Before Editing',
    TITLE_DETAIL_EDIT_AFTER: 'After Editing',
    TITLE_EXPORT_AUDIT_LOG: 'audit_log_{0}.xlsx',
    TITLE_DOWNLOAD_AUDIT_LOG: 'Download the imported file'
  },
  OU_SECURITY: {
    TXT_MFA: 'Multi-Factor Authentication',
    TXT_LOGIN_PROTECTION: 'Login Protection',
    BTN_SUBMIT_SECURITY: 'Apply Changes',
    TXT_CLOSE_LOGIN_PROTECTION: 'Disabled',
    TXT_OPEN_EMAIL_AUTH: 'Enable Email Authentication',
    TXT_EMAIL_AUTH_HINT:
      'When users log in to the system, they need to perform an extra step of entering the verification code that has been sent to their email address.',
    TXT_LOGIN_VALIDATE: 'Login Authentication',
    LABEL_EMAIL_ADDRESS: 'Email',
    LABEL_VERITIFICATION_CODE: 'Verification Code',
    BTN_SEND_CODE: 'Send Verification Code ',
    TXT_INPUT_CODE: 'Enter your verification code',
    TXT_BACK_TO_LOGIN: 'Back to login',
    HINT_CODE_SENDED: 'Verification code is sent through email',
    HINT_WRONG_CODE: 'Verification code is not valid. Please try again.',
    HINT_CODE_REQUIRED: 'Enter your verification code',
    BIN_RESEND_CODE: 'Resend',
    PRMTMSG_SEND_CODE_SUCCEED: 'Multi-factor authentication settings are updated',

    MSG_CIPHER_RULES: 'The following password rules apply to all internal user accounts in this OU',
    LABEL_CIPHER_RETRY_CONSTRAINT_BOTTOM: 'The number of incorrect password entries allowed in 1 hour. The account will be locked for {0} minutes if this limit is exceeded. Supports 1 - 10 retries.',
    LABEL_REPEAT_TIMES_BOTTOM: 'The number of previous passwords that cannot be reused. Supports 1 to 5 passwords.',
    LABEL_SESSION_VALID_TIME_AFTER: 'hours',
    LABEL_SESSION_VALID_TIME_BOTTOM: 'The period of time a user can stay inactive before they get logged out. Supports 1 - 240 hours.',
    TXT_SESSION_VALID_TIME: 'Session Timeout'

  },
  ALARM: {
    COLH_ORIGIN: 'Origin',
    TXT_EMPTY: 'No data available',
    TXT_ACTIVE_ALARM: 'Active Alarm',
    TXT_GOTO_LIST: 'Go to Alarm Console',
    COLH_SEV: 'Severity',
    COLH_ALARMTYPE: 'Alarm Type',
    COLH_SITE: 'Site',
    COLH_SITETYPE: 'Site Type',
    COLH_DEVICE: 'Device',
    COLH_DEVICETYPE: 'Device Type',
    COLH_CPTTYPE: 'Component Type',
    COLH_COMPONENT: 'Component',
    COLH_CONTENT: 'Content',
    COLH_START: 'Start Time',
    COLH_END: 'End Time',
    TXT_LAST_UPDATE: 'Last Refresh at',
    TXT_ENABLE_SOUND: 'Enable Sound',
    TXT_DISABLE_SOUND: 'Disable Sound',
    TXT_ENABLE_POP: 'Enable Pop-up',
    TXT_DISABLE_POP: 'Disable Pop-up',
    TXT_REFRESH: 'Refresh',
    TXT_ACK: 'Ack',
    TXT_ACKED: 'Acked',
    COLH_DUR: 'Duration',
    COLH_OPERATION: 'Operation',
    TXT_ALL: 'All ({0})'
  },
  LANDING_PAGE: {
    LABEL_SITE_TIME: 'Site Time',
    HINT_CUSTOMIZE: 'Edit Page',
    BTN_ADD_WIDGET: 'Add Widget',
    BTN_SAVE: 'Save',
    BTN_EXIT: 'Exit',
    PLACEHOLD_SEARCH_NAME: 'Search by name',
    TXT_NO_MATCH: 'No matching results',
    BTN_ADD_TO_PAGE: 'Add to Page',
    TITLE_EXIT_CONFIRM: 'Exit Edit Mode?',
    TXT_UNSAVE_TIP: 'Unsaved configurations will be lost',
    BTN_CANCEL: 'Cancel',
    MSG_FAILED_TO_GET_ASSET: 'Failed to get asset tree',
    TXT_DAY: 'Day',
    TXT_MONTH: 'Month',
    TXT_YEAR: 'Year',
    TXT_MTD: 'MTD',
    TXT_30d: '30d',
    TXT_QTD: 'QTD',
    TXT_3m: '3m',
    TXT_YTD: 'YTD',
    TXT_12m: '12m',
    TXT_Custom: 'Custom',
    LABEL_TIME_INTERVAL: 'Time Interval: ',
    LABEL_SITEM_SELECTED: 'Site: Selected ({0})'
  }
};

export default locale;
